// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Customs_customUpload__lGrod {
	border-radius: 4px;
	border: 1px dashed rgba(56, 78, 183, 0.3);
	background: #f8f8ff;
	padding: 19px 0 24px;
}

.Customs_customUploadIcon__3RvAX {
	width: 68.783px;
	height: 59.587px;
	flex-shrink: 0;
}

.Customs_desktopUploadText__EbYYa {
	color: #0f0f0f;
	text-align: center;
	margin-top: 12px;
	font-family: Mulish;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px; /* 150% */
}

.Customs_mobileUploadText__ICJLC {
	display: none !important;
}

.Customs_uploadUnderline__uKqsT {
	color: #483ea8 !important;
	text-decoration-line: underline !important;
}

.Customs_supportedFormats__7wgSP {
	margin-top: 10px;
	color: #676767;
	text-align: center;
	font-family: Mulish;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
}

.Customs_cancelUpload__ENX2X {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	fill: #e6e6e6;
}

.Customs_fileName__pDJ6O {
	color: #0f0f0f;
	text-align: center;
	font-family: Mulish;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
}

.Customs_deleteUpload__vNyaj {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.Customs_uploadCon__CaYAM {
	padding: 12px 12px 12px 22px;
	border-radius: 4px;
	border: 0.5px solid #e3e3e3;
	background: #fff;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) {
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.Customs_desktopUploadText__EbYYa {
		display: none !important;
	}

	.Customs_mobileUploadText__ICJLC {
		display: flex !important;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Customs.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,yCAAyC;CACzC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CAEC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,aAAa;AACd;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA,yDAAyD;AACzD;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".customUpload {\n\tborder-radius: 4px;\n\tborder: 1px dashed rgba(56, 78, 183, 0.3);\n\tbackground: #f8f8ff;\n\tpadding: 19px 0 24px;\n}\n\n.customUploadIcon {\n\twidth: 68.783px;\n\theight: 59.587px;\n\tflex-shrink: 0;\n}\n\n.desktopUploadText {\n\tcolor: #0f0f0f;\n\ttext-align: center;\n\tmargin-top: 12px;\n\tfont-family: Mulish;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 24px; /* 150% */\n}\n\n.mobileUploadText {\n\tcomposes: desktopUploadText;\n\tdisplay: none !important;\n}\n\n.uploadUnderline {\n\tcolor: #483ea8 !important;\n\ttext-decoration-line: underline !important;\n}\n\n.supportedFormats {\n\tmargin-top: 10px;\n\tcolor: #676767;\n\ttext-align: center;\n\tfont-family: Mulish;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 150% */\n}\n\n.cancelUpload {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n\tfill: #e6e6e6;\n}\n\n.fileName {\n\tcolor: #0f0f0f;\n\ttext-align: center;\n\tfont-family: Mulish;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 150% */\n}\n\n.deleteUpload {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n}\n\n.uploadCon {\n\tpadding: 12px 12px 12px 22px;\n\tborder-radius: 4px;\n\tborder: 0.5px solid #e3e3e3;\n\tbackground: #fff;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) {\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.desktopUploadText {\n\t\tdisplay: none !important;\n\t}\n\n\t.mobileUploadText {\n\t\tdisplay: flex !important;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customUpload": `Customs_customUpload__lGrod`,
	"customUploadIcon": `Customs_customUploadIcon__3RvAX`,
	"desktopUploadText": `Customs_desktopUploadText__EbYYa`,
	"mobileUploadText": `Customs_mobileUploadText__ICJLC Customs_desktopUploadText__EbYYa`,
	"uploadUnderline": `Customs_uploadUnderline__uKqsT`,
	"supportedFormats": `Customs_supportedFormats__7wgSP`,
	"cancelUpload": `Customs_cancelUpload__ENX2X`,
	"fileName": `Customs_fileName__pDJ6O`,
	"deleteUpload": `Customs_deleteUpload__vNyaj`,
	"uploadCon": `Customs_uploadCon__CaYAM`
};
export default ___CSS_LOADER_EXPORT___;
